import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DocumentIndexDataService {

  public shouldRefreshParticipants$ = new Subject<{refreshParticipants: boolean}>();


  constructor(private _http$: HttpClient) { }





  /**
   * Update Document Owner
   * @param documentId 
   * @param ownerId 
   * @returns 
   */
  updateDocumentOwner(documentId: number, ownerId: number){
    return this._http$.put(`documents/${documentId}/changeOwner`, {owner_id: ownerId});
  }
}
